module.exports = __webpack_public_path__ + "img/hand-pointer.f2ab0593.svg";